export const PREFIX_PHONE_NUMBER = {
  FR: "+33",
};
